import React, { useState } from "react";
import "./Dictionary.css";
import Footer from "./Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

function Dictionary() {
	const [searchTerm, setSearchTerm] = useState("");
	const [openTerm, setOpenTerm] = useState(null);

	const dictionary = {
		"Major Depressive Disorder (MDD)": {
			presentation:
				"Persistent feelings of sadness or a lack of interest in external stimuli. Symptoms include changes in sleep, appetite, energy level, concentration, daily behavior, or self-esteem. Suicidal thoughts may also occur",
		},
		"Generalized Anxiety Disorder (GAD)": {
			presentation:
				"Excessive, uncontrollable worry about a variety of topics. This worry is often accompanied by symptoms such as restlessness, fatigue, concentration problems, irritability, muscle tension, and sleep disturbances",
		},
		"Bipolar Disorder": {
			presentation:
				"Characterized by mood swings that include emotional highs (mania or hypomania) and lows (depression). Symptoms of mania include increased energy, euphoria, and decreased need for sleep. Depressive episodes present similar symptoms to MDD",
		},
		Schizophrenia: {
			presentation:
				"A severe mental disorder characterized by delusions, hallucinations, disorganized thinking, and impaired functioning. Symptoms can be positive (hallucinations, delusions), negative (apathy, lack of emotion), or cognitive (disorganized thinking)",
		},
		"Obsessive-Compulsive Disorder (OCD)": {
			presentation:
				"Characterized by unwanted, persistent, intrusive thoughts (obsessions) and repetitive behaviors or mental acts (compulsions) that the individual feels driven to perform. These behaviors are aimed at reducing anxiety or preventing a feared event",
		},
		"Post-Traumatic Stress Disorder (PTSD)": {
			presentation:
				"Triggered by a terrifying event, either experiencing it or witnessing it. Symptoms include flashbacks, nightmares, severe anxiety, and uncontrollable thoughts about the event. Individuals may also avoid situations that remind them of the event",
		},
		"Attention-Deficit/Hyperactivity Disorder (ADHD)": {
			presentation:
				"Characterized by a persistent pattern of inattention and/or hyperactivity-impulsivity that interferes with functioning or development. Symptoms include difficulty sustaining attention, hyperactivity, and impulsive behavior",
		},
		"Autism Spectrum Disorder (ASD)": {
			presentation:
				"A developmental disorder that affects communication and behavior. Symptoms include difficulties with social communication and interaction, and restricted, repetitive patterns of behavior, interests, or activities",
		},
		"Panic Disorder": {
			presentation:
				"Recurrent unexpected panic attacks, which are sudden periods of intense fear that may include palpitations, sweating, shaking, shortness of breath, numbness, or a feeling of impending doom.",
		},
		"Borderline Personality Disorder (BPD)": {
			presentation:
				"A pervasive pattern of instability in interpersonal relationships, self-image, and affects, and marked impulsivity. Symptoms include efforts to avoid real or imagined abandonment, a pattern of unstable relationships, identity disturbance, impulsive behaviors, recurrent suicidal behavior, affective instability, chronic feelings of emptiness, inappropriate anger, and transient stress-related paranoid ideation or severe dissociative symptoms",
		},
		"Social Anxiety Disorder (Social Phobia)": {
			presentation:
				"Intense fear of social situations where one may be scrutinized by others. This fear leads to avoidance of such situations or enduring them with intense distress",
		},
		"Anorexia Nervosa": {
			presentation:
				"An eating disorder characterized by an intense fear of gaining weight and a distorted body image, leading to restricted food intake, excessive exercise, or other behaviors to lose weight. It often results in significantly low body weight",
		},
		"Bulimia Nervosa": {
			presentation:
				"An eating disorder characterized by recurrent episodes of binge eating followed by inappropriate compensatory behaviors such as vomiting, fasting, excessive exercise, or misuse of laxatives",
		},
		"Substance Use Disorder": {
			presentation:
				"A condition in which the use of one or more substances leads to a clinically significant impairment or distress. Symptoms include an inability to control use, social problems, risky use, and physiological effects such as tolerance and withdrawal",
		},
		"Obsessive-Compulsive Personality Disorder (OCPD)": {
			presentation:
				"A pervasive pattern of preoccupation with orderliness, perfectionism, and control. Unlike OCD, the behaviors and thoughts are viewed as appropriate and correct by the individual",
		},
	};

	const filteredTerms = Object.entries(dictionary)
		.filter(([term]) => term.toLowerCase().includes(searchTerm.toLowerCase()))
		.sort(([termA], [termB]) => termA.localeCompare(termB));

	return (
		<div className="dictionary-container">
			<section className="department-section">
				<div className="main-content">
					<div className="terms-column">
						<div className="dictionary-search-wrapper">
							<FontAwesomeIcon icon={faSearch} className="search-icon" />
							<input
								type="text"
								placeholder="Search terms..."
								value={searchTerm}
								onChange={(e) => setSearchTerm(e.target.value)}
								className="search-input"
							/>
						</div>
						<div style={{ height: "75vh", overflowY: "scroll" }}>
							{filteredTerms.map(([term]) => (
								<div
									key={term}
									className={`dictionary-term ${
										openTerm === term ? "active" : ""
									}`}
									onClick={() => setOpenTerm(openTerm === term ? null : term)}
								>
									<h3>{term}</h3>
								</div>
							))}
						</div>
					</div>
					<div className="content-column">
						{openTerm && (
							<div className="dictionary-item">
								<h2>{openTerm}</h2>
								<div className="dictionary-content">
									<p>{dictionary[openTerm].presentation}</p>
								</div>
							</div>
						)}
					</div>
				</div>
			</section>
			<Footer />
		</div>
	);
}

export default Dictionary;
